import { optionSchema, nullableOptionSchema } from "@/common/schemas/option.schema";
import { z } from "zod"

export const createSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho mínimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  unit_for_quantity: z.object({
    label: z.string(),
    value: z.string()
  }, {message: 'Campo obrigatório'}),
  category: z.object({
    label: z.string(),
    value: z.string()
  }, {message: 'Campo obrigatório'}),
  equipment_category_ids: z.array(nullableOptionSchema).optional().nullable(),
  product_tef_identifiers: z
    .array(
      z.object({
        identifier_id: z.string().optional(),
        tef_provider: nullableOptionSchema.optional().nullable(),
        identifier: z.string().optional(),
      }),
    )
    .optional()
    .superRefine((data, ctx) => {
      data?.forEach((item, index) => {
        const tefProvider = item.tef_provider?.value || ''
        const identifier = item.identifier?.trim() || ''

        if (tefProvider && !identifier) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Identificador é obrigatório quando o Provedor TEF é preenchido',
          })
        }

        if (tefProvider === 'fiserv' && identifier?.length < 6) {
          ctx.addIssue({
            path: [index, 'identifier'],
            code: z.ZodIssueCode.custom,
            message: 'Tamanho obrigatório: 6 caracteres',
          })
        }

        if (tefProvider === 'linx' && identifier?.length < 3) {
          ctx.addIssue({
            path: [index, 'identifier'],
            code: z.ZodIssueCode.custom,
            message: 'Tamanho obrigatório: 3 caracteres',
          })
        }
      })
    }),
  equipment_tier: optionSchema.optional().nullable(),
  fiscal_document_kind: optionSchema.optional().nullable(),
})

export type ProductValidationSchema = z.infer<typeof createSchema>
